import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { COMPANY_PROFILE_CARD_DATA_TOKEN, CrmInjectionToken } from '@galaxy/crm/static';
import { MatCardModule } from '@angular/material/card';
import { GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { CrmFulfillmentProjectsAssociationCardService } from './fulfillment-projects.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'crm-fulfillment-projects-association-card',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatCardModule,
    GalaxyBadgeModule,
  ],
  templateUrl: './fulfillment-projects.component.html',
  styleUrls: ['../association-panel-shared.scss', './fulfillment-projects.component.scss'],
  providers: [CrmFulfillmentProjectsAssociationCardService],
})
export class CrmFulfillmentProjectsAssociationCardComponent {
  private readonly service = inject(CrmFulfillmentProjectsAssociationCardService);
  private readonly data = inject(COMPANY_PROFILE_CARD_DATA_TOKEN);
  private readonly config = inject(CrmInjectionToken);

  protected readonly pageSize = this.service.pageSize;
  protected readonly hasMore$ = this.service.hasMore$;
  protected readonly items$ = this.service.items$;
  protected readonly hasItems$ = this.service.hasItems$;
  protected readonly showViewAllAction: boolean;

  constructor() {
    this.service.setAccountGroupId(this.data.account_group_id ?? '');
    this.config.namespace$.pipe(takeUntilDestroyed()).subscribe((partnerId) => this.service.setPartnerId(partnerId));
    this.showViewAllAction = this.config?.customActions?.navigateToFulfillmentProjects instanceof Function;
  }

  protected handleViewAllClick(): void {
    this.config?.customActions?.navigateToFulfillmentProjects?.({
      objectType: 'Company',
      objectId: this.data.company_id,
    });
  }

  protected handleShowMoreClick(): void {
    this.service.fetchNext();
  }
}
